import type { Option } from '../../format/pieces';

export const inRow = (options: Option[]): boolean => {
  return options.length <= 4 && options.every(option => option.label.length <= 14);
};

export const inListOrder = (ids: string[], options: Option[]): string[] => {
  return options.filter(option => ids.includes(option.id)).map(option => option.id);
};
